import React, {useState, useCallback,useEffect } from 'react';
import {PDFViewer, Document, Page, Text, View, StyleSheet } from '@react-pdf/renderer';
import CancelSharpIcon from '@material-ui/icons/CancelSharp';
import SaveIcon from '@material-ui/icons/Save';
import * as apiClient from "../../common/apiClient";
import { FormToolbar } from "../../common/FormToolbar";
import {Table,TableHeader,TableCell,TableBody,DataTableCell} from '@david.kucsai/react-pdf-table'
import { BorderLeft } from '@material-ui/icons';
const styles = StyleSheet.create({
  page: {
       paddingTop: 120,
    paddingBottom: 50,
    paddingHorizontal: 5,
    paddingRight: 15,
    paddingLeft: 30,
    
  },
  headerContainer: {
    marginTop: 10,
    textAlign: 'center',
    flexDirection: "row",
    fontSize:14
  },
  headerRow: {
    marginTop: 8,
    flexDirection: "row",
    
  },
  headerFirstLabel: {
    marginTop: 0,
    fontSize:11,
    
    width:45,
    textAlign:"left",
    marginRight:2,
    fontWeight:"extrabold"

  },
  headerFirstField: {
    marginTop: 0,
    fontSize:10,
    textAlign:"left",
    width:175,
    marginRight:5,
    marginLeft:5,
    
    
    
  },
  headerSecondLabel: {
    marginTop: 0,
    fontSize:11,
    fontWeight:"bold",
    width:55,
    textAlign:"left",
    marginRight:2

  },
  headerSecondField: {
    marginTop: 0,
    fontSize:10,
    textAlign:"left",
    width:90,
    marginLeft:5,
    
  },
  headerLastLabel: {
    marginTop: 0,
    fontSize:11,
    fontWeight:"bold",
    width:120,
    textAlign:"left",
    marginRight:2
    
  },
  headerLastField: {
    marginTop: 0,
    fontSize:10,
    textAlign:"left",
    width:90,
    marginRight:5,
    marginLeft:5,
  },
  headerRemarksLabel: {
    marginTop: 0,
    fontSize:11,
    
    width:100,
    textAlign:"left",
    marginRight:2,
    fontWeight:"extrabold"

  },
  headerRemarksField: {
    marginTop: 0,
    fontSize:10,
    textAlign:"left",
    width:"100%",
    marginRight:5,
    marginLeft:5,
    
    
    
  },
  
  
  headerTable: {
    fontSize:12,
    height:40,
    textAlign: 'center',
    fontWeight:"bold",
    border:"none"
    
  },
  detailTable:{
    marginTop:50
  },
  tableHeader: {
    fontSize:11,
    height:30,
    textAlign: 'center',
    fontWeight:"bold"
    
  },
  tableRow: {
    fontSize:9,
    height:25,
    textAlign: 'center',
  }
});
 

const HospitalPrint = props => {
   const hospitalData=[ {firstName: "John", lastName: "Smith", dob: new Date(2000, 1, 1), country: "Australia", phoneNumber: "xxx-0000-0000"},{firstName: "John", lastName: "Smith", dob: new Date(2000, 1, 1), country: "Australia", phoneNumber: "xxx-0000-0000"},{firstName: "John", lastName: "Smith", dob: new Date(2000, 1, 1), country: "Australia", phoneNumber: "xxx-0000-0000"},{firstName: "John", lastName: "Smith", dob: new Date(2000, 1, 1), country: "Australia", phoneNumber: "xxx-0000-0000"},{firstName: "John", lastName: "Smith", dob: new Date(2000, 1, 1), country: "Australia", phoneNumber: "xxx-0000-0000"},{firstName: "John", lastName: "Smith", dob: new Date(2000, 1, 1), country: "Australia", phoneNumber: "xxx-0000-0000"},{firstName: "John", lastName: "Smith", dob: new Date(2000, 1, 1), country: "Australia", phoneNumber: "xxx-0000-0000"},{firstName: "John", lastName: "Smith", dob: new Date(2000, 1, 1), country: "Australia", phoneNumber: "xxx-0000-0000"},{firstName: "John", lastName: "Smith", dob: new Date(2000, 1, 1), country: "Australia", phoneNumber: "xxx-0000-0000"},{firstName: "John", lastName: "Smith", dob: new Date(2000, 1, 1), country: "Australia", phoneNumber: "xxx-0000-0000"},{firstName: "John", lastName: "Smith", dob: new Date(2000, 1, 1), country: "Australia", phoneNumber: "xxx-0000-0000"},{firstName: "John", lastName: "Smith", dob: new Date(2000, 1, 1), country: "Australia", phoneNumber: "xxx-0000-0000"},{firstName: "John", lastName: "Smith", dob: new Date(2000, 1, 1), country: "Australia", phoneNumber: "xxx-0000-0000"},{firstName: "John", lastName: "Smith", dob: new Date(2000, 1, 1), country: "Australia", phoneNumber: "xxx-0000-0000"},{firstName: "John", lastName: "Smith", dob: new Date(2000, 1, 1), country: "Australia", phoneNumber: "xxx-0000-0000"},{firstName: "John", lastName: "Smith", dob: new Date(2000, 1, 1), country: "Australia", phoneNumber: "xxx-0000-0000"},{firstName: "John", lastName: "Smith", dob: new Date(2000, 1, 1), country: "Australia", phoneNumber: "xxx-0000-0000"},{firstName: "John", lastName: "Smith", dob: new Date(2000, 1, 1), country: "Australia", phoneNumber: "xxx-0000-0000"}]
   const [isLoading, setLoading] = useState(true);
   const [hTpa, sethTPA] = useState([]);
   const [hInsu, sethInsu] = useState([]);
   const [hHospital, sethHospital] = useState({});
    
    const LoadData= (id) => {
        

        apiClient.getGetHospitalDataForPrint (id).then(res => {
           
           sethHospital(res.headerData[0]);
           console.log(res.headerData);
           sethTPA(res.tapData);
           sethInsu(res.insurerData);
           setLoading(false);
        
        }).catch(err => {
          alert(err)
          setLoading(false);
            console.log(err);
        });

    }
    useEffect(() => {LoadData(props.hospitalId);},[]);
    return (

      
      <React.Fragment> 
        <div>
          <div style={{float:"right"}}  onClick={props.onClose}><CancelSharpIcon/></div>
        </div>
        {isLoading===false?
        <PDFViewer width="100%" height="600" >
          <Document title="report" >
              <Page size="A4" style={styles.page}>
                <View>
                  <View style={styles.headerContainer} fixed>
                      <Text>  Hostpital List </Text>
                  </View>
                  <View style={styles.headerRow} >
                      <Text style={styles.headerFirstLabel}>Code.: </Text>
                      <Text style={styles.headerFirstField}>{hHospital.Code}</Text>
                      <Text style={styles.headerSecondLabel}>License #: </Text>
                      <Text style={styles.headerSecondField}>{hHospital.LICNO}</Text>
                      <Text style={styles.headerLastLabel}> HDC Agreement Dt. </Text>
                      <Text style={styles.headerLastField}> {hHospital.OpenDate} </Text>
                      
                  </View>
                  <View style={styles.headerRow} >
                      <Text style={styles.headerFirstLabel} >Name: </Text>
                      <Text style={styles.headerFirstField}>{hHospital.Name}</Text>
                      <Text style={styles.headerSecondLabel}>GST #: </Text>
                      <Text style={styles.headerSecondField}>{hHospital.CSTNo}</Text>
                      <Text style={styles.headerLastLabel} >Cont. Person Mob. #: </Text>
                      <Text style={styles.headerLastField}>{hHospital.CpMob1}</Text>
                      
                  </View>
                  <View style={styles.headerRow} >
                      <Text style={styles.headerFirstLabel} >Area: </Text>
                      <Text style={styles.headerFirstField}>{hHospital.Area} </Text>
                      <Text style={styles.headerSecondLabel}>PAN #: </Text>
                      <Text style={styles.headerSecondField}>{hHospital.Panno} </Text>
                      <Text style={styles.headerLastLabel} >Cont. Person Res. #: </Text>
                      <Text style={styles.headerLastField}>{hHospital.CpRes1}</Text>
                      
                  </View>
                  <View style={styles.headerRow} >
                      <Text style={styles.headerFirstLabel} >Address: </Text>
                      <Text style={styles.headerFirstField}>{hHospital.Address} </Text>
                      <Text style={styles.headerSecondLabel}>Bank-Name : </Text>
                      <Text style={styles.headerSecondField}>{hHospital.Cpname2}</Text>
                      <Text style={styles.headerLastLabel} >Certification Details: </Text>
                      <Text style={styles.headerLastField}>{hHospital.CpMob2} </Text>
                      
                  </View>
                  <View style={styles.headerRow} >
                      <Text style={styles.headerFirstLabel} >City: </Text>
                      <Text style={styles.headerFirstField}>{hHospital.City} </Text>
                      <Text style={styles.headerSecondLabel}>Branch: </Text>
                      <Text style={styles.headerSecondField}>{hHospital.Cpname3} </Text>
                      <Text style={styles.headerLastLabel} >Realisation Details: </Text>
                      <Text style={styles.headerLastField}>{hHospital.Cpmob3}</Text>
                      
                  </View>
                  <View style={styles.headerRow} >
                      <Text style={styles.headerFirstLabel} >State: </Text>
                      <Text style={styles.headerFirstField}>{hHospital.State} </Text>
                      <Text style={styles.headerSecondLabel}>IFSC-Code: </Text>
                      <Text style={styles.headerSecondField}>{hHospital.Cpname4}</Text>
                      <Text style={styles.headerLastLabel} >TIP UP Charge Details: </Text>
                      <Text style={styles.headerLastField}>{hHospital.Cpmob4}</Text>
                      
                  </View>
                  <View style={styles.headerRow} >
                      <Text style={styles.headerFirstLabel} >PIN: </Text>
                      <Text style={styles.headerFirstField}>{hHospital.PinCode} </Text>
                      <Text style={styles.headerSecondLabel}>Ac No: </Text>
                      <Text style={styles.headerSecondField}>{hHospital.Cpname5}</Text>
                      <Text style={styles.headerLastLabel} >Cont Person : </Text>
                      <Text style={styles.headerLastField}>{hHospital.Cpname1} </Text>
                      
                  </View>
                  <View style={styles.headerRow} >
                      <Text style={styles.headerFirstLabel} > Email : </Text>
                      <Text style={styles.headerFirstField}>{hHospital.Email} </Text>
                      <Text style={styles.headerSecondLabel}>Phone : </Text>
                      <Text style={styles.headerSecondField}>{hHospital.phoffice}</Text>
                      <Text style={styles.headerLastLabel} >Mobile: </Text>
                      <Text style={styles.headerLastField}>{hHospital.phmobile} </Text>
                  </View>
                  <View style={styles.headerRow} >
                      <Text style={styles.headerFirstLabel} >Fire LIC : </Text>
                      <Text style={styles.headerFirstField}>{hHospital.FireLIC} </Text>
                      <Text style={styles.headerSecondLabel}>Pollution : </Text>
                      <Text style={styles.headerSecondField}>{hHospital.Pollution}  </Text>
                      <Text style={styles.headerLastLabel} >CE License: </Text>
                      <Text style={styles.headerLastField}>{hHospital.CE_License} </Text>
                  </View>
                  <View style={styles.headerRow} >
                      <Text style={styles.headerFirstLabel} >PPN: </Text>
                      <Text style={styles.headerFirstField}>{hHospital.PPN} </Text>
                      <Text style={styles.headerSecondLabel}>PNDT : </Text>
                      <Text style={styles.headerSecondField}>{hHospital.Pndt} </Text>
                      <Text style={styles.headerLastLabel} >Biomedical Waste: </Text>
                      <Text style={styles.headerLastField}>{hHospital.Bio_Med_Waste}</Text>
                  </View>
                  
                  <View style={styles.headerRow} >
                      <Text style={styles.headerFirstLabel} >NABH: </Text>
                      <Text style={styles.headerFirstField}>{hHospital.NABH} </Text>
                      <Text style={styles.headerSecondLabel}>Rohini ID : </Text>
                      <Text style={styles.headerSecondField}>{hHospital.RohiniID}</Text>
                  </View>
                  <View style={styles.headerRow} >
                      <Text style={styles.headerRemarksLabel} >Remarks: </Text>
                      <Text style={styles.headerRemarksField}>{hHospital.Remarks} </Text>
                  
                  </View>
                 {hTpa && hTpa.length>0? 
                 
                 <View style={styles.detailTable} >
                    <View style={styles.headerRow} >
                      <Text style={styles.headerRemarksLabel} >TPAs: </Text>
                  </View>
                  <Table  data={hTpa} >
                    <TableHeader>
                        <TableCell style={styles.tableHeader}> TPA Name </TableCell>                         
                        <TableCell style={styles.tableHeader}> Empanelled </TableCell>
                        <TableCell style={styles.tableHeader}> Tie-Up </TableCell>
                        <TableCell style={styles.tableHeader}> Agrmnt. F Dt </TableCell>
                        <TableCell style={styles.tableHeader}> Agrmnt. T Dt. </TableCell>
                        <TableCell style={styles.tableHeader}> Remarks </TableCell>
                        
                    </TableHeader>
                    <TableBody>
                        <DataTableCell style={styles.tableRow} getContent={(r) => r.Name}/>
                        <DataTableCell style={styles.tableRow} getContent={(r) => r.isTieUp}/>
                        <DataTableCell style={styles.tableRow} getContent={(r) => r.Empanelled}/>
                        <DataTableCell style={styles.tableRow} getContent={(r) => r.AgrmtFDt}/>
                        <DataTableCell style={styles.tableRow} getContent={(r) => r.AgrmtTDt}/>
                        <DataTableCell style={styles.tableRow} getContent={(r) => r.Remakrs}/> 
                    </TableBody>
                </Table>                  
                </View>:null}

                {hInsu && hInsu.length>0? 
                 
                 <View style={styles.detailTable} >
                    <View style={styles.headerRow} >
                      <Text style={styles.headerRemarksLabel} >Insu: </Text>
                  </View>
                  <Table  data={hInsu} >
                    <TableHeader>
                        <TableCell style={styles.tableHeader}> TPA Name </TableCell>                         
                        <TableCell style={styles.tableHeader}> Empanelled </TableCell>
                        <TableCell style={styles.tableHeader}> Tie-Up </TableCell>
                        <TableCell style={styles.tableHeader}> Tie-Up </TableCell>
                        <TableCell style={styles.tableHeader}> Agrmnt. Dt. </TableCell>
                        <TableCell style={styles.tableHeader}> Remarks </TableCell>
                        
                    </TableHeader>
                    <TableBody>
                        <DataTableCell style={styles.tableRow} getContent={(r) => r.Name}/>
                        <DataTableCell style={styles.tableRow} getContent={(r) => r.isTieUp}/>
                        <DataTableCell style={styles.tableRow} getContent={(r) => r.Empanelled}/>
                        <DataTableCell style={styles.tableRow} getContent={(r) => r.AgrmtFDt}/>
                        <DataTableCell style={styles.tableRow} getContent={(r) => r.AgrmtTDt}/>
                        <DataTableCell style={styles.tableRow} getContent={(r) => r.Remakrs}/> 
                    </TableBody>
                </Table>                  
                </View>:null}
              </View>
              </Page>
          </Document>
         </PDFViewer>:null}
        </React.Fragment>
    );
}
export default HospitalPrint;